"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPronunciationVideo = exports.PronunciationVideoSchema = exports.isVideoDefinition = void 0;
const z = __importStar(require("zod"));
const type_validation_helpers_1 = require("../helpers/type_validation_helpers");
const VideoDefinitionSchema = z.object({
    button_txt: z.string(),
    duration: z.number(),
    group: z.string(),
    id: z.number(),
    title: z.string(),
    url: z.string(),
    watch_order: z.number(),
});
const isVideoDefinition = (x) => VideoDefinitionSchema.safeParse(x).success;
exports.isVideoDefinition = isVideoDefinition;
exports.PronunciationVideoSchema = VideoDefinitionSchema.extend({
    first_view: z.string().optional(),
});
exports.isPronunciationVideo = type_validation_helpers_1.getTypeValidationFunction(exports.PronunciationVideoSchema);
//# sourceMappingURL=videos.js.map